import { FC } from "react"
import { ResetPassword } from "../../../module/users/containers/resetPassword"

export const ResetPasswordPage: FC = () => <ResetPassword />
